<template>
<div class="wrapper">
    <!-- header -->
    <!-- 大網展開menu: header-menu-sec 移除hidden -->
    <!-- 小網展開menu: wrapper 加class="header-nav-open" -->
    <header>
      <div class="pagesize">
        <div class="header-area">
          <h1><router-link to="/"><span class="zh">士林區區域電能管理系統</span><br /><span class="eng">SHILIN Community Energy Management
                System </span></router-link></h1>
          <p class="header-time">更新時間：{{updateTime}}</p>
          <a href="#" class="header-nav-btn"></a>
          <div class="header-nav">
            <a href="./login" class="btn-login" @click="LOGIN_OUT">登出</a>
            <ul class="header-menu-first">
              <li><router-link to="/" class="on">能源地圖</router-link></li>
              <li><router-link to="/electricity">發用電資訊</router-link></li>
              <li><a href="#"  class="folder">需量反應</a>
                <ul class="header-menu-sec">
                  <li><router-link to="./bidCalc">投標試算</router-link></li>
                  <li><router-link to="./bidRecord">得標及抑低分配發布</router-link></li>
                  <li><router-link to="./realTime">即時執行情形</router-link></li>
                  <li><router-link to="./history">歷史紀錄</router-link></li>
                  <li><router-link to="./group">群組成員資料</router-link></li>
                  <li><router-link to="./download">下載專區</router-link></li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </header>
    <!-- container -->
    <div class="container">
      <div class="pagesize">
        <div class="dashboard">
          <div class="weather-area area bg-light">
            <div class="padding03 bg-white">
              <!-- 即時天氣 -->
              <div class="weather-today">
                <div class="weather-today-img">
                  <!-- <img src="./images/weather/weather01.png"> -->
                   <img :src="currentWeather[2]">
                </div>
                <div class="weather-today-inner">
                  <h2 class="boxtitle">即時天氣</h2>
                  <p class="tempNum margin03 "><span>{{currentWeather[0]}}</span>&nbsp;℃</p>
                  <p><span class="tag">降雨機率{{pop}}<span class="font-recursive">%</span></span>{{currentWeather[3]}}</p>
                </div>
              </div>
              <hr class="line">
              <!-- 太陽能 -->
              <div class="solar-area">
                <h2 class="boxtitle margin02" style="font-size:19px">今日累計太陽能發電量</h2>
                <p class="num">{{solarKwh}} kWh</p>
              </div>
            </div>
            <div class="padding03 bg-dark">
              <a class="f-right btn btn-small btn-goto bg-kahki" href="https://dbp.taipower.com.tw/TaiPowerDBP/Portal/Login" target="_blank">投標連結</a>
              <h2 class="boxtitle f-left"><span class="color-white">{{bidnote.title}}<span
                    class="color-yellow-light">{{bidnote.do}}</span>倒數</span></h2>
              <div class="clr margin02"></div>
              <p class="text-contdown">{{countdownTimer(getTimenow)}}</p>
            </div>
            <div class="padding03 bg-light">
              <!-- 備轉容量 -->
              <div class="reserve-area">
                <div class="reserve-inner">
                  <h2 class="boxtitle"><span class="color-white">明日預估<br />備轉容量率</span></h2>
                  <p class="reserve-status">供電充裕</p>
                </div>
                <div class="reserve-img">
                  <!-- <img src="images/index_weather03.png" alt=""> -->
                  <!-- bar -->
                  <div class="SemiCircleBar-box">
                    <div class="SemiCircleBar" id='SemiCircleBar'></div>
                    <p class="min">0</p>
                    <p class="max">15</p>
                  </div>
                </div>
              </div>
              <h2 class="boxtitle margin" style="margin:10px 0px">
                <span class="color-white">供電燈號</span>
              </h2>
              <div class="imgbox full">
                <img src="./images/index_weather04.png">
              </div>
            </div>
          </div>
          <div class="map area bg-white padding03">
            <h2 class="tagtitleIndex"><span>能源地圖</span></h2>
            <div class="mobile">
              <select class="w-100p color-white-blue02">
                <option>士林區行政中心</option>
                <option>士林運動中心</option>
              </select>
            </div>
            <div class="map-area">
              <div class="map-img imgbox">
                <!-- SVG -->
                <div class="map-svg">
                  <!-- svg -->
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 470 460">
                    <defs>
                      <svg:style>
                        .pin-off {
                          fill: #b2dee9;
                          filter: drop-shadow(0 0 10px rgba(0, 0, 0, 0.2));
                          transition: 0.2s;
                        }

                        .pin-on {
                          fill: #c3b014;
                        }

                        .signal-off {
                          fill: #8a8686;
                        }

                        .signal-on {
                          fill: #e66426;
                        }

                        .title {
                          opacity: 0.98;
                          isolation: isolate;
                          font-size: 16px;
                          fill: #323333;
                          font-family: Noto Sans CJK TC;
                        }

                        .line {
                          fill: none;
                          stroke: #bcab1f;
                          stroke-linejoin: round;
                          stroke-dasharray: 1000;
                          animation: draw 3s ease-out;
                        }

                        @keyframes draw {
                          from {
                            stroke-dashoffset: 1000;
                          }

                          to {
                            stroke-dashoffset: 0;
                          }
                        }
                      </svg:style>
                    </defs>
                    <!-- 底圖 -->
                    <g id="map">
                      <path style=" fill: #90d1d7;"
                        d="M465.8,256.81l-9.22-1.1V252.2l.88-4.38-2.19-3.07,3.29-6.58v-3.95l-5.92,2.19-7.24-9.65-3.07-4.38-6.8-2.42-3.07-6.14-6.14-3.07.88-8.55-7.46-8.33s.44-7.24,0-8.56-12.06-5-12.06-5l-.66-2.41,7-12.94-1.1-12.27s-4.82-6.15-4.82-6.81-2-8.55-2-8.55h-1.53l-2.85,1.53-6.8-3.51-8.55-6.58-6.14,1.32-7.46-1.32-7-5v-11l18.42-19.08,2.2-9L382.24,79l-.66-3.51s-3.73-2.58-3.73-3.81a56.35,56.35,0,0,1,1.1-6.06l4.61-3.73-4.17-7.45,5.48-5.48V45.4l3.29-1.76.22-4.16-2-1.1.65-7.9-4.38-3.07,5-5-11.4-3.95-4.83,5-9.91-4.57.47,4-9.59,2.61-19.53,21.6,3.64,5.7-1.38,3.63,1.34,5.17L326.1,80.45l-5,1.36-9.51,9.71L317,105.28l2.67,7.85-3.85,3.5-3.63,20-15.25,9.12-13.29,30.35-.17.14c-3.24,2.75-6.81,5.92-7.43,6.68-.17,1-.76,6.73-1.11,10.27l0,.18-7.4,14.8-4,3.7-7.31,2.85-3.31-1.56H248.1l-36.71,23.77-.4,3.39,1.94,4.7.65,17.3,2.48,1.82V268l-6.15,6.81-1.2,7.23-12.38,3.63-2,8.45-2.69,1.35-2.51,7,1.59,3,4.07,6.62v4.6a14.47,14.47,0,0,0,1.42,1.95l.23.28v7.59h-3.84l-7,4.18v3.69l-4.54,3.7-1.26,5.5c-.55,1.76-2.35,7.53-2.69,8.21s-3.23,3.41-5.66,5.64l-2.67,5.75-1.58,7.11a12.34,12.34,0,0,1,4.59-.19,30.61,30.61,0,0,1,8.88,4.44l9.54-4.93s-1.81,3.45-3.29,4.27-7.57,2.14-8.06,2.14-6.42-5.26-8.88-4.44-17.77,5.59-18.59,5.92-6.09,3.18-6.09,3.18l2,3.57-3.46,2,.05.35a14.05,14.05,0,0,1-1.55-1.34c-1.09-1.32-12.94-2.19-14.91-2.19s-12.94.65-16-1.76-5.48-4.82-5.92-8.11a12.9,12.9,0,0,1,1.29-7c.42-.88-.63-11.62-.19-13.38s0-15.35,0-16.88-4.17-11.41-4.83-12.59S88.4,315.47,86.43,315s-11.84,0-14.69,1.1-16.67,9.21-19.08,10.31-6.14,2.41-6.8,3.39-11.19.33-11.84,0-7,1.87-7,1.87H13.4L.24,328c-1.09,2.08,1.76,4.61,4,8.66s7.46,4.06,8,4.06,4.28,4.94,4.61,5.05,7.46-1,7.79-1,14.25,5,14.8,5a210.25,210.25,0,0,1,25,8c9.21,3.84,40.24,31.47,40.24,31.47s10.2,9.1,13.71,12.17,8.44,12.06,8.44,12.06,6.8,6.69,10.31,14.7c1.74,4,3.1,9.51,4.4,15H160.3l7.25-3a88.41,88.41,0,0,0,16.93,10c.46.16,5.63,4.59,7,7.59l.78.65,1.78-.51-6-16.06,1.4-5.58,8.9-.85,11.26-10.93.2-.08c1.41-.49,3.6-1.61,4-2.55.84-1.8,8.93-14.59,9.27-15.13l.14-.23,12.2-6.43L244,397l7.32,2.09.09,0c3.29,1.78,7,3.71,7.9,4.12,2-.52,16.13-4.59,25.57-7.33l.68-.2,6.42-6.42h2v-3.53l7.05-7,1.45-4,22.17-2.18,9.8-4.29v-4.2l3.12-3.13v-5.57l10.9-6.64,5.14-5.14h12.76l4.44,3.52,5.9-4.51h7.67L395,332.56l3.5-14.18,6.72-2.91h12l1.65-4.44h4.07l1.32,2.47H429c1.56-2.73,3.24-5.62,3.88-6.47,1.32-1.76,4-10.53,4-10.53l4.16-3.29s3.51-7.67,3.51-8.33.66-11.4,1.32-11.62a18.71,18.71,0,0,1,3.51,0c.66,0,3.73,2.63,4.38,2.63s2.42-.44,2.85-1.1,2.64-5.7,2.64-5.7l7.45-6.58Z" />
                    </g>
                    <!-- 地圖點 -->
                    <g id="pin" class="cursor">
                      <!-- pin01 -->
                      <g class="pin-off" v-if="!lightSite['士東市場']" @click="light('士東市場')">
                        <path
                          d="M223.89,297.27a4.5,4.5,0,1,1-4.5,4.5,4.51,4.51,0,0,1,4.5-4.5m0-3a7.5,7.5,0,1,0,7.5,7.5,7.5,7.5,0,0,0-7.5-7.5Z" />
                          <circle class="cls-5" cx="224.13" cy="301.76" r="7.5" fill="transparent"></circle>
                      </g>
                      <!-- on -->
                      <g v-if="lightSite['士東市場']">
                        <circle class="cls-5" cx="224.13" cy="301.76" r="10" fill="#c5e6bb">
                          <animate dur="2s" attributeName="r" keyTimes="0; 0.7; 1" values="10; 15; 10"
                            repeatCount="indefinite" />
                        </circle>
                        <circle class="cls-5" cx="224.13" cy="301.76" r="7.5" fill="#c3b014"></circle>
                      </g>
                      <!-- pin02 -->
                      <g class="pin-off" v-if="!lightSite['天文科學教育館']" @click="light('天文科學教育館')">
                        <path
                          d="M199.57,333.57a4.5,4.5,0,1,1-4.5,4.5,4.51,4.51,0,0,1,4.5-4.5m0-3a7.5,7.5,0,1,0,7.5,7.5,7.5,7.5,0,0,0-7.5-7.5Z" />
                          <circle cx="199.8" cy="338.06" r="7.5" fill="transparent"></circle>
                      </g>
                      <!-- on -->
                      <g v-if="lightSite['天文科學教育館']">
                        <circle cx="199.8" cy="338.06" r="10" fill="#c5e6bb">
                          <animate dur="2s" attributeName="r" keyTimes="0; 0.7; 1" values="10; 15; 10" repeatCount="indefinite"/>
                        </circle>
                        <circle cx="199.8" cy="338.06" r="7.5" fill="#c3b014"></circle>
                      </g>
                      <!-- pin03 -->
                      <g class="pin-off" v-if="!lightSite['士林區行政中心']" @click="light('士林區行政中心')">
                        <path
                          d="M206.21,353.1a4.5,4.5,0,1,1-4.5,4.5,4.51,4.51,0,0,1,4.5-4.5m0-3a7.5,7.5,0,1,0,7.5,7.5,7.5,7.5,0,0,0-7.5-7.5Z" />
                          <circle cx="206.45" cy="357.59" r="7.5" fill="transparent"></circle>
                      </g>
                      <!-- on -->
                      <g v-if="lightSite['士林區行政中心']">
                        <circle cx="206.45" cy="357.59" r="10" fill="#c5e6bb">
                          <animate dur="2s" attributeName="r" keyTimes="0; 0.7; 1" values="10; 15; 10" repeatCount="indefinite"/>
                        </circle>
                        <circle cx="206.45" cy="357.59" r="7.5" fill="#c3b014"></circle>
                      </g>
                      <!-- pin04 -->
                      <g class="pin-off" v-if="!lightSite['士林運動中心']" @click="light('士林運動中心')">
                        <path
                          d="M215,370.55a4.5,4.5,0,1,1-4.5,4.5,4.51,4.51,0,0,1,4.5-4.5m0-3a7.5,7.5,0,1,0,7.5,7.5,7.5,7.5,0,0,0-7.5-7.5Z" />
                          <circle cx="214.95" cy="375.04" r="7.5" fill="transparent"></circle>
                      </g>
                      <!-- on -->
                      <g v-if="lightSite['士林運動中心']">
                        <circle cx="214.95" cy="375.04" r="10" fill="#c5e6bb">
                          <animate dur="2s" attributeName="r" keyTimes="0; 0.7; 1" values="10; 15; 10" repeatCount="indefinite"/>
                        </circle>
                        <circle cx="214.95" cy="375.04" r="7.5" fill="#c3b014"></circle>
                      </g>
                      <!-- pin05 -->
                      <g class="pin-off" v-if="!lightSite['士林市場']" @click="light('士林市場')">
                        <path
                          d="M233.34,382.48a4.5,4.5,0,1,1-4.5,4.5,4.51,4.51,0,0,1,4.5-4.5m0-3a7.5,7.5,0,1,0,7.5,7.5,7.5,7.5,0,0,0-7.5-7.5Z" />
                          <circle cx="233.34" cy="386.97" r="7.5" fill="transparent"></circle>
                      </g>
                      <!-- on -->
                      <g v-if="lightSite['士林市場']">
                        <circle cx="233.34" cy="386.97" r="10" fill="#c5e6bb">
                          <animate dur="2s" attributeName="r" keyTimes="0; 0.7; 1" values="10; 15; 10" repeatCount="indefinite"/>
                        </circle>
                        <circle cx="233.34" cy="386.97" r="7.5" fill="#c3b014"></circle>
                      </g>
                      <!-- pin06 -->
                      <g class="pin-off" v-if="!lightSite['士林分局']" @click="light('士林分局')">
                        <path
                          d="M254.19,357.62a4.5,4.5,0,1,1-4.5,4.5,4.5,4.5,0,0,1,4.5-4.5m0-3a7.5,7.5,0,1,0,7.5,7.5,7.5,7.5,0,0,0-7.5-7.5Z" />
                          <circle cx="254.19" cy="362.11" r="7.5" fill="transparent"></circle>
                      </g>
                      <!-- on -->
                      <g v-if="lightSite['士林分局']">
                        <circle cx="254.19" cy="362.11" r="10" fill="#c5e6bb">
                          <animate dur="2s" attributeName="r" keyTimes="0; 0.7; 1" values="10; 15; 10" repeatCount="indefinite"/>
                        </circle>
                        <circle cx="254.19" cy="362.11" r="7.5" fill="#c3b014"></circle>
                      </g>
                    </g>
                    <!-- 訊號 -->
                    <g id="signal">
                      <!-- signal01 -->
                      <!-- <g class="signal-off">
                        <path d="M237.35,297a1.06,1.06,0,0,0,0,1.48.9.9,0,0,0,1.29,0A11,11,0,0,1,246,295.6a9.46,9.46,0,0,1,1.07.06l.84-1.93A12.82,12.82,0,0,0,237.35,297Z"/>
                        <path d="M250.18,294.29l-.8,1.85a11.21,11.21,0,0,1,4.07,2.38.91.91,0,0,0,1.3,0,1.05,1.05,0,0,0-.05-1.48A13.17,13.17,0,0,0,250.18,294.29Z"/>
                        <path d="M250.79,301.43a.91.91,0,0,0,1.26-.09h0a1,1,0,0,0-.05-1.47,9.23,9.23,0,0,0-3.42-1.87l-.81,1.87A7.46,7.46,0,0,1,250.79,301.43Z"/>
                        <path d="M246,297.63a9.13,9.13,0,0,0-6,2.24,1,1,0,0,0-.06,1.47l0,0a.88.88,0,0,0,1.23.05,7.41,7.41,0,0,1,4.09-1.75l.88-2Z"/>
                        <path d="M248.12,304.37a.92.92,0,0,0,1.2-.12h0a1.06,1.06,0,0,0-.16-1.58,5.52,5.52,0,0,0-2.21-.91l-.85,1.95A3.56,3.56,0,0,1,248.12,304.37Z"/>
                        <path d="M242.9,302.67a1.07,1.07,0,0,0-.17,1.58.93.93,0,0,0,.53.27l1.12-2.59A5.4,5.4,0,0,0,242.9,302.67Z"/>
                        <path class="cls-7" d="M246.08,305.55H246a1,1,0,0,0-.62,1.74.93.93,0,0,0,1.35,0A1,1,0,0,0,246.08,305.55Z"/>
                        <path d="M251.24,290.13a.49.49,0,0,0-.22-.64.45.45,0,0,0-.6.24l-7.67,17.68a.49.49,0,0,0,.22.63.49.49,0,0,0,.19,0,.48.48,0,0,0,.42-.28Z"/>
                      </g> -->
                      <g class="signal-on">
                        <path d="M254.7,297a12.73,12.73,0,0,0-17.35,0,1.06,1.06,0,0,0,0,1.48.91.91,0,0,0,1.29,0,10.9,10.9,0,0,1,14.85,0,.92.92,0,0,0,1.3,0A1.05,1.05,0,0,0,254.7,297Z"/>
                        <path d="M246,297.62a9.13,9.13,0,0,0-6,2.24,1,1,0,0,0-.06,1.47l0,0a.87.87,0,0,0,1.23.05,7.29,7.29,0,0,1,9.52,0,.89.89,0,0,0,1.26-.09h0a1,1,0,0,0-.05-1.47A9.13,9.13,0,0,0,246,297.62Z"/>
                        <path d="M249.16,302.66a5.44,5.44,0,0,0-6.26,0,1.07,1.07,0,0,0-.17,1.58.93.93,0,0,0,1.21.12,3.59,3.59,0,0,1,4.18,0,.92.92,0,0,0,1.2-.12A1.06,1.06,0,0,0,249.16,302.66Z"/>
                        <path class="cls-8" d="M246.08,305.54H246a1,1,0,0,0-.62,1.74.93.93,0,0,0,1.35,0A1,1,0,0,0,246.08,305.54Z"/>
                      </g>
                      <!-- signal02 -->
                      <!-- <g class="signal-off">
                        <path
                          d="M58.74,321.33a1.05,1.05,0,0,0-.05,1.48.91.91,0,0,0,1.29.05,11,11,0,0,1,7.43-2.92c.36,0,.72,0,1.07.05l.84-1.92A12.72,12.72,0,0,0,58.74,321.33Z" />
                        <path
                          d="M71.57,318.63l-.81,1.85a11.33,11.33,0,0,1,4.08,2.38.91.91,0,0,0,1.29-.05,1.05,1.05,0,0,0,0-1.48A13,13,0,0,0,71.57,318.63Z" />
                        <path
                          d="M72.17,325.77a.92.92,0,0,0,1.27-.09h0a1,1,0,0,0-.06-1.48A9.37,9.37,0,0,0,70,322.33l-.81,1.88A7.33,7.33,0,0,1,72.17,325.77Z" />
                        <path
                          d="M67.41,322a9.13,9.13,0,0,0-6,2.24,1,1,0,0,0-.06,1.48l0,0a.88.88,0,0,0,1.23.06A7.27,7.27,0,0,1,66.74,324l.89-2Z" />
                        <path
                          d="M69.5,328.7a.92.92,0,0,0,1.21-.12h0a1.06,1.06,0,0,0-.17-1.57,5.42,5.42,0,0,0-2.21-.92l-.85,2A3.71,3.71,0,0,1,69.5,328.7Z" />
                        <path
                          d="M64.28,327a1.06,1.06,0,0,0-.17,1.57.92.92,0,0,0,.53.28l1.12-2.59A5.4,5.4,0,0,0,64.28,327Z" />
                        <path class="cls-7"
                          d="M67.47,329.88h-.12a1,1,0,0,0-.62,1.74.92.92,0,0,0,1.36,0A1,1,0,0,0,67.47,329.88Z" />
                        <path
                          d="M72.62,314.47a.49.49,0,0,0-.22-.64.44.44,0,0,0-.6.24l-7.66,17.67a.49.49,0,0,0,.22.64.41.41,0,0,0,.19,0,.45.45,0,0,0,.41-.28Z" />
                      </g> -->
                      <g class="signal-on">
                        <path d="M76.08,321.32a12.72,12.72,0,0,0-17.34,0,1.07,1.07,0,0,0-.05,1.49.91.91,0,0,0,1.29,0,10.91,10.91,0,0,1,14.86,0,.91.91,0,0,0,1.29,0A1.07,1.07,0,0,0,76.08,321.32Z" />
                        <path d="M67.41,322a9.13,9.13,0,0,0-6,2.24,1,1,0,0,0-.06,1.47l0,0a.88.88,0,0,0,1.23.05,7.25,7.25,0,0,1,9.52,0,.92.92,0,0,0,1.27-.09h0a1,1,0,0,0-.06-1.47A9.13,9.13,0,0,0,67.41,322Z" />
                        <path d="M70.54,327a5.44,5.44,0,0,0-6.26,0,1.06,1.06,0,0,0-.17,1.57.91.91,0,0,0,1.21.12,3.64,3.64,0,0,1,4.18,0,.91.91,0,0,0,1.21-.12A1.06,1.06,0,0,0,70.54,327Z" />
                        <path d="M67.47,329.87h-.12a1,1,0,0,0-.62,1.74.92.92,0,0,0,1.36,0A1,1,0,0,0,67.47,329.87Z" />
                      </g>
                      <!-- signal03 -->
                      <!-- <g class="signal-off">
                        <path d="M56.66,351a1.07,1.07,0,0,0,0,1.49.92.92,0,0,0,1.3,0,11,11,0,0,1,7.42-2.92,9.64,9.64,0,0,1,1.08.06l.83-1.92A12.75,12.75,0,0,0,56.66,351Z" />
                        <path d="M69.49,348.33l-.8,1.85a11.12,11.12,0,0,1,4.07,2.37.91.91,0,0,0,1.29,0A1.07,1.07,0,0,0,74,351,13,13,0,0,0,69.49,348.33Z" />
                        <path d="M70.1,355.46a.91.91,0,0,0,1.26-.09h0a1,1,0,0,0-.06-1.47A9.22,9.22,0,0,0,67.88,352l-.81,1.87A7.56,7.56,0,0,1,70.1,355.46Z" />
                        <path d="M65.33,351.66a9.15,9.15,0,0,0-6,2.24,1,1,0,0,0,0,1.47l0,0a.88.88,0,0,0,1.23,0,7.41,7.41,0,0,1,4.09-1.75l.89-2Z" />
                        <path d="M67.43,358.4a.92.92,0,0,0,1.2-.12h0a1.07,1.07,0,0,0-.16-1.58,5.5,5.5,0,0,0-2.22-.91l-.84,1.95A3.61,3.61,0,0,1,67.43,358.4Z" />
                        <path d="M62.2,356.7a1.07,1.07,0,0,0-.16,1.58,1,1,0,0,0,.52.28l1.13-2.6A5.76,5.76,0,0,0,62.2,356.7Z" />
                        <path class="cls-7" d="M65.39,359.58h-.11a1,1,0,0,0-.62,1.74.91.91,0,0,0,1.35,0A1,1,0,0,0,65.39,359.58Z" />
                        <path d="M70.55,344.16a.49.49,0,0,0-.22-.63.43.43,0,0,0-.6.23l-7.67,17.68a.5.5,0,0,0,.22.64.43.43,0,0,0,.19,0,.45.45,0,0,0,.41-.28Z" />
                      </g> -->
                      <g class="signal-on">
                        <path
                          d="M74,351a12.73,12.73,0,0,0-17.35,0,1.05,1.05,0,0,0,0,1.48.92.92,0,0,0,1.3.05,10.9,10.9,0,0,1,14.85,0,.91.91,0,0,0,1.29-.05A1.05,1.05,0,0,0,74,351Z" />
                        <path
                          d="M65.33,351.65a9.15,9.15,0,0,0-6,2.24,1,1,0,0,0,0,1.47l0,0a.88.88,0,0,0,1.23.06,7.27,7.27,0,0,1,9.53,0,.9.9,0,0,0,1.26-.1h0a1,1,0,0,0-.06-1.47A9.11,9.11,0,0,0,65.33,351.65Z" />
                        <path
                          d="M68.47,356.69a5.46,5.46,0,0,0-6.27,0,1.07,1.07,0,0,0-.16,1.58.91.91,0,0,0,1.2.12,3.61,3.61,0,0,1,4.19,0,.91.91,0,0,0,1.2-.12A1.07,1.07,0,0,0,68.47,356.69Z" />
                        <path d="M65.39,359.57h-.11a1,1,0,0,0-.62,1.74.91.91,0,0,0,1.35,0A1,1,0,0,0,65.39,359.57Z" />
                      </g>
                      <!-- signal04 -->
                      <!-- <g class="signal-off">
                        <path
                          d="M81.74,377.41a1.05,1.05,0,0,0,0,1.48.92.92,0,0,0,1.29.05A10.94,10.94,0,0,1,90.41,376a9.47,9.47,0,0,1,1.07.05l.84-1.92A12.72,12.72,0,0,0,81.74,377.41Z" />
                        <path
                          d="M94.57,374.71l-.81,1.85a11.19,11.19,0,0,1,4.08,2.38.92.92,0,0,0,1.29-.05,1.05,1.05,0,0,0,0-1.48A12.74,12.74,0,0,0,94.57,374.71Z" />
                        <path
                          d="M95.17,381.84a.9.9,0,0,0,1.27-.09h0a1,1,0,0,0-.06-1.47A9.37,9.37,0,0,0,93,378.41l-.81,1.87A7.46,7.46,0,0,1,95.17,381.84Z" />
                        <path
                          d="M90.41,378a9.13,9.13,0,0,0-6,2.24,1,1,0,0,0-.06,1.47l0,0a.87.87,0,0,0,1.23,0,7.33,7.33,0,0,1,4.09-1.74l.89-2.05Z" />
                        <path
                          d="M92.5,384.78a.92.92,0,0,0,1.21-.12h0a1.07,1.07,0,0,0-.17-1.58,5.54,5.54,0,0,0-2.21-.91l-.85,1.95A3.63,3.63,0,0,1,92.5,384.78Z" />
                        <path
                          d="M87.28,383.08a1.07,1.07,0,0,0-.17,1.58.92.92,0,0,0,.53.28l1.12-2.59A5.67,5.67,0,0,0,87.28,383.08Z" />
                        <path class="cls-7"
                          d="M90.47,386h-.12a1,1,0,0,0-.62,1.74.92.92,0,0,0,1.36,0A1,1,0,0,0,90.47,386Z" />
                        <path
                          d="M95.62,370.55a.48.48,0,0,0-.22-.64.44.44,0,0,0-.6.23l-7.66,17.68a.49.49,0,0,0,.22.64.41.41,0,0,0,.19,0,.45.45,0,0,0,.41-.28Z" />
                      </g> -->
                      <g class="signal-on">
                        <path d="M99.08,377.4a12.72,12.72,0,0,0-17.34,0,1.05,1.05,0,0,0,0,1.48.9.9,0,0,0,1.29.05,10.91,10.91,0,0,1,14.86,0,.9.9,0,0,0,1.29-.05A1.05,1.05,0,0,0,99.08,377.4Z" />
                        <path d="M90.41,378a9.08,9.08,0,0,0-6,2.24,1,1,0,0,0-.06,1.47l0,0a.88.88,0,0,0,1.23.06,7.25,7.25,0,0,1,9.52,0,.92.92,0,0,0,1.27-.09h0a1,1,0,0,0-.06-1.47A9.08,9.08,0,0,0,90.41,378Z" />
                        <path d="M93.54,383.08a5.4,5.4,0,0,0-6.26,0,1.06,1.06,0,0,0-.17,1.57.92.92,0,0,0,1.21.12,3.64,3.64,0,0,1,4.18,0,.92.92,0,0,0,1.21-.12A1.06,1.06,0,0,0,93.54,383.08Z" />
                        <path d="M90.47,386h-.12a1,1,0,0,0-.62,1.74.92.92,0,0,0,1.36,0A1,1,0,0,0,90.47,386Z" />
                      </g>
                      <!-- signal05 -->
                      <!-- <g class="signal-off">
                        <path d="M251.53,382.45a1.05,1.05,0,0,0,0,1.48.91.91,0,0,0,1.29.05,11,11,0,0,1,7.43-2.92c.36,0,.72,0,1.07.05l.83-1.92A12.72,12.72,0,0,0,251.53,382.45Z" />
                        <path d="M264.36,379.75l-.8,1.85a11.15,11.15,0,0,1,4.07,2.38.91.91,0,0,0,1.29-.05,1.05,1.05,0,0,0,0-1.48A12.86,12.86,0,0,0,264.36,379.75Z" />
                        <path d="M265,386.89a.9.9,0,0,0,1.26-.1h0a1,1,0,0,0-.05-1.47,9.53,9.53,0,0,0-3.42-1.87l-.82,1.87A7.33,7.33,0,0,1,265,386.89Z" />
                        <path d="M260.21,383.08a9.16,9.16,0,0,0-6,2.24,1,1,0,0,0,0,1.47l0,0a.88.88,0,0,0,1.23.06,7.27,7.27,0,0,1,4.09-1.75l.89-2.05Z" />
                        <path d="M262.3,389.82a.91.91,0,0,0,1.2-.12h0a1.07,1.07,0,0,0-.16-1.58,5.66,5.66,0,0,0-2.21-.91l-.85,2A3.66,3.66,0,0,1,262.3,389.82Z" />
                        <path d="M257.07,388.12a1.07,1.07,0,0,0-.16,1.58.9.9,0,0,0,.52.28l1.13-2.59A5.89,5.89,0,0,0,257.07,388.12Z" />
                        <path class="cls-7" d="M260.26,391h-.11a1,1,0,0,0-.62,1.74.91.91,0,0,0,1.35,0A1,1,0,0,0,260.26,391Z" />
                        <path d="M265.42,375.59a.5.5,0,0,0-.22-.64.44.44,0,0,0-.6.23l-7.67,17.68a.51.51,0,0,0,.22.64.43.43,0,0,0,.19,0,.44.44,0,0,0,.41-.28Z" />
                      </g> -->
                      <g class="signal-on">
                        <path
                          d="M268.88,382.44a12.73,12.73,0,0,0-17.35,0,1.05,1.05,0,0,0,0,1.48.9.9,0,0,0,1.29.05,10.9,10.9,0,0,1,14.85,0,.9.9,0,0,0,1.29-.05A1.05,1.05,0,0,0,268.88,382.44Z" />
                        <path
                          d="M260.21,383.08a9.16,9.16,0,0,0-6,2.24,1,1,0,0,0,0,1.47l0,0a.89.89,0,0,0,1.23.05,7.27,7.27,0,0,1,9.53,0,.91.91,0,0,0,1.26-.09h0a1,1,0,0,0-.05-1.47A9.15,9.15,0,0,0,260.21,383.08Z" />
                        <path
                          d="M263.34,388.12a5.41,5.41,0,0,0-6.27,0,1.05,1.05,0,0,0-.16,1.57.91.91,0,0,0,1.2.12,3.66,3.66,0,0,1,4.19,0,.91.91,0,0,0,1.2-.12A1.05,1.05,0,0,0,263.34,388.12Z" />
                        <path d="M260.26,391h-.11a1,1,0,0,0-.62,1.74.91.91,0,0,0,1.35,0A1,1,0,0,0,260.26,391Z" />
                      </g>
                      <!-- signal06 -->
                      <!-- <g class="signal-off">
                        <path d="M268,359.83a1.06,1.06,0,0,0,0,1.48.91.91,0,0,0,1.29.05,11,11,0,0,1,7.43-2.92c.36,0,.72,0,1.07.05l.84-1.92A12.78,12.78,0,0,0,268,359.83Z" />
                        <path d="M280.8,357.13,280,359a11.21,11.21,0,0,1,4.07,2.38.92.92,0,0,0,1.3-.05,1.05,1.05,0,0,0-.05-1.48A13.17,13.17,0,0,0,280.8,357.13Z" />
                        <path d="M281.41,364.27a.92.92,0,0,0,1.27-.09h0a1,1,0,0,0-.06-1.47,9.23,9.23,0,0,0-3.42-1.87l-.81,1.87A7.46,7.46,0,0,1,281.41,364.27Z" />
                        <path d="M276.65,360.46a9.09,9.09,0,0,0-6,2.25,1,1,0,0,0-.06,1.47l0,0a.89.89,0,0,0,1.23,0,7.34,7.34,0,0,1,4.09-1.75l.88-2Z" />
                        <path d="M278.74,367.2a.9.9,0,0,0,1.2-.12h0a1,1,0,0,0-.16-1.57,5.54,5.54,0,0,0-2.21-.92l-.85,2A3.71,3.71,0,0,1,278.74,367.2Z" />
                        <path d="M273.52,365.51a1.06,1.06,0,0,0-.17,1.57.89.89,0,0,0,.53.28l1.12-2.59A5.4,5.4,0,0,0,273.52,365.51Z" />
                        <path class="cls-7" d="M276.7,368.38h-.11a1,1,0,0,0-.62,1.74.92.92,0,0,0,1.36,0A1,1,0,0,0,276.7,368.38Z" />
                        <path d="M281.86,353a.49.49,0,0,0-.22-.64.45.45,0,0,0-.6.24l-7.67,17.67a.5.5,0,0,0,.23.64.41.41,0,0,0,.18.05.47.47,0,0,0,.42-.28Z" />
                      </g> -->
                      <g class="signal-on">
                        <path
                          d="M285.32,359.83a12.71,12.71,0,0,0-17.35,0,1.06,1.06,0,0,0,0,1.48.91.91,0,0,0,1.29,0,10.93,10.93,0,0,1,14.85,0,.92.92,0,0,0,1.3,0A1.05,1.05,0,0,0,285.32,359.83Z" />
                        <path
                          d="M276.65,360.46a9.13,9.13,0,0,0-6,2.24,1,1,0,0,0-.06,1.47l0,0a.88.88,0,0,0,1.23.05,7.25,7.25,0,0,1,9.52,0,.92.92,0,0,0,1.27-.09h0a1,1,0,0,0-.06-1.47A9.13,9.13,0,0,0,276.65,360.46Z" />
                        <path
                          d="M279.78,365.5a5.44,5.44,0,0,0-6.26,0,1.07,1.07,0,0,0-.17,1.58.93.93,0,0,0,1.21.12,3.59,3.59,0,0,1,4.18,0,.92.92,0,0,0,1.2-.12A1.06,1.06,0,0,0,279.78,365.5Z" />
                        <path d="M276.7,368.38h-.11a1,1,0,0,0-.62,1.73.92.92,0,0,0,1.36,0A1,1,0,0,0,276.7,368.38Z" />
                      </g>
                    </g>
                    <!-- title -->
                    <g id="title">
                      <text class="title" transform="translate(257.83 306.55)">士東市場</text>
                      <text class="title" transform="translate(79 331.15)">天文科學教育館</text>
                      <text class="title" transform="translate(78.14 362.11)">士林區行政中心</text>
                      <text class="title" transform="translate(106.96 386.5)">士林運動中心</text>
                      <text class="title" transform="translate(274.1 392.02)">士林市場</text>
                      <text class="title" transform="translate(290.34 368.37)">士林分局</text>
                    </g>
                    <!-- 連線 -->
                    <g id="line">
                      <!-- line01 -->
                      <path v-if="lightSite['士東市場']" class="line" storke="#bcab1f" storke-width="1" d="M224 301 414 0.5 455 0.5" />
                      <!-- line02 -->
                      <path v-if="lightSite['天文科學教育館']" class="line" storke="#bcab1f" storke-width="1" d="M200 338 414 0.5 455 0.5" />
                      <!-- line03 -->
                      <path v-if="lightSite['士林區行政中心']" class="line" storke="#bcab1f" storke-width="1" d="M206 357 414 0.5 455 0.5" />
                      <!-- line04 -->
                      <path v-if="lightSite['士林運動中心']" class="line" storke="#bcab1f" storke-width="1" d="M215 375 414 0.5 455 0.5" />
                      <!-- line05 -->
                      <path v-if="lightSite['士林市場']" class="line" storke="#bcab1f" storke-width="1" d="M234 388 414 0.5 455 0.5" />
                      <!-- line06 -->
                      <path v-if="lightSite['士林分局']" class="line" storke="#bcab1f" storke-width="1" d="M254 362 414 0.5 455 0.5" />
                    </g>
                  </svg>
                </div>
                <!-- <img src="img/index_map.png"> -->
              </div>
              <div class="map-inner">
                <div class="mapinfo">
                  <div class="mapinfo-text">
                    <h3>{{eneryTitle}}</h3>
                    <p>{{eneryAddress}}</p>
                    <p>網路連線狀態
                      <span class="stetustag font-size-m" v-if="enerySign">正常</span>
                      <span class="stetustag font-size-m" style="background-color:gray" v-else>斷線</span>
                    </p>
                    <p class="color-kahki-light">用電需量占比(用電需量/契約容量) <span
                        class="font-recursive font-size-xxl weight-bold">{{enreyPercent}}%</span></p>
                  </div>
                  <div class="imgbox" style="min-height:330px">
                    <!-- <img src="./images/index_map_place05.jpg"> -->
                    <img :src="eneryImg">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--  footer -->
    <footer>
      <div class="pagesize">
        <div class="footer-info">
          <div class="info-box info-main">
            <div class="logo"></div>
            <div class="copyright">
              <p><a href="#">政府網站資料開放宣告</a>&nbsp;|&nbsp;<a href="#">隱私權及網站安全政策</a></p>
              <p>Copyright © All Rights Reserved</p>
            </div>
          </div>
          <div class="info-box info-sub">
            <p>執行單位：(02)2586-5000 # 325 陳小姐</p>
            <div class="logo02"></div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<style scoped>
    @import './css/index.css';
    .cursor > g{
      cursor: pointer;
    }
</style>

<script>
import { mapMutations, mapGetters, mapState, mapActions } from 'vuex'
import progressbar from './js/jquery.progressbar'
import importJQ from './js/main'
import { DateTime } from 'luxon'
import axios from 'axios'
import cookies from 'vue-cookies'
import { dbDataHandle, countDown } from '../store/function/index'
import img1 from './images/index_map_place05.jpg'
import img2 from './images/index_map_place06.jpg'
import img3 from './images/index_map_place03.jpg'
import img4 from './images/index_map_place04.jpg'
import img5 from './images/index_map_place01.jpg'
import img6 from './images/index_map_place02.png'
export default {
  data () {
    return {
      updateTime: DateTime.local().toFormat('yyyy-MM-dd HH:mm:ss'),
      img1,
      img2,
      enerySign: false,
      eneryTitle: '士林區行政中心',
      eneryAddress: '臺北市士林區中正路439號',
      enreyPercent: 55,
      eneryImg: img2,
      menu: false,
      pinLight: false,
      CBLTime: '',
      bidnote: {
        title: '',
        do: ''
      },
      SiteInfo: [
        {
          site: '士林運動中心',
          address: '臺北市士林區士商路1號',
          img: img1,
          Percent: 55,
          sign: false
        },
        {
          ems: 'SHILIN',
          site: '士林區行政中心',
          address: '臺北市士林區中正路439號',
          img: img2,
          Percent: 87,
          sign: true
        },
        {
          site: '士東市場',
          address: '臺北市士林區士東路100號',
          img: img5,
          Percent: 40,
          sign: true
        },
        {
          site: '士林分局',
          address: '臺北市士林區文林路235號',
          img: img6,
          Percent: 53,
          sign: true
        },
        {
          ems: 'SHILIN_MARKET',
          site: '士林市場',
          address: '臺北市士林區基河路1號',
          img: img3,
          Percent: 68,
          sign: true
        },
        {
          ems: 'SHILIN_SPORTS_CENTER',
          site: '士林運動中心',
          address: '臺北市士林區士商路1號',
          img: img1,
          Percent: 68,
          sign: true
        },
        {
          ems: 'TAIPEI_ASTRONOMICAL_MUSEUM',
          site: '天文科學教育館',
          address: '臺北市士林區基河路363號',
          img: img4,
          Percent: 70,
          sign: true
        }
      ],
      lightSite: {
        士林運動中心: false,
        士東市場: false,
        士林市場: false,
        士林區行政中心: true,
        天文科學教育館: false,
        士林分局: false
      }
    }
  },
  methods: {
    ...mapActions([
      'getSolarKwToday',
      'getContractRate'
    ]),
    ...mapMutations([
      'COUNTING_TIMER',
      'LOGIN_OUT'
    ]),
    dbDataHandle (num, index) {
      return dbDataHandle(num, index)
    },
    countdownTimer () {
      if (this.CBLTime) {
        const cblDate = this.CBLTime.data.date ? this.CBLTime.data.date : this.CBLTime.data[0].date
        const cblStartTime = this.CBLTime.data.timeStart ? this.CBLTime.data.timeStart : this.CBLTime.data[0].timeStart
        const cblString = cblDate + ' ' + cblStartTime
        const today = DateTime.local().toFormat('yyyy-MM-dd HH:mm')
        const time = cblStartTime.slice(0, 2)
        const minute = cblStartTime.slice(-2)
        const year = cblDate.slice(0, 4)
        const month = cblDate.slice(5, 7)
        const date = cblDate.slice(-2)
        if (today > cblString) {
          this.bidnote.title = '需量反應'
          this.bidnote.do = '投標'
          return countDown(11)
        } else {
          this.bidnote.title = '已得標'
          this.bidnote.do = '執行'
          return countDown(time, minute, year, month, date)
        }
      } else {
        this.bidnote.title = '需量反應'
        this.bidnote.do = '投標'
        return countDown(11)
      }
    },
    secMenu () {
      this.menu = !this.menu
    },
    light (str) {
      this.lightSite = {
        士林運動中心: false,
        士東市場: false,
        士林市場: false,
        士林區行政中心: false,
        天文科學教育館: false
      }
      if (str) {
        this.lightSite[str] = !this.lightSite[str]
      }
      for (let i = 0; i < this.SiteInfo.length; i++) {
        if (this.SiteInfo[i].site === str) {
          const whichSite = this.contractRate.find(x => x.ems === this.SiteInfo[i].ems)
          if (whichSite) {
            this.enreyPercent = this.dbDataHandle(whichSite.data * 100)
          } else {
            this.enreyPercent = this.SiteInfo[i].Percent
          }
          this.eneryTitle = this.SiteInfo[i].site
          this.eneryAddress = this.SiteInfo[i].address
          this.eneryImg = this.SiteInfo[i].img
          this.enerySign = this.SiteInfo[i].sign
        }
      }
    },
    async reserverateProgress () {
      const date = DateTime.local().plus({ day: 1 }).toFormat('yyyy-MM-dd')
      const data = await axios.get(`https://tpcems.tier.org.tw/api/tpcems/open/home/operating-reserve-by-date?date=${date}`)
      var barValue = data.data.operatingReserveRate // 設定數值顯示文字
      var bar = new progressbar.SemiCircle('.SemiCircleBar', {
        strokeWidth: 6,
        color: '#c0ff37',
        trailColor: '#fff',
        trailWidth: 6,
        easing: 'easeInOut',
        duration: 1000,
        svgStyle: null,
        text: {
          value: ''
          // alignToBottom: true
        },
        step: function (state, circle) {
          circle.setText(barValue)
        }
      })
      bar.animate(barValue / 15) /* b設定bar參數  0~1.0 */
    },
    async getCBLTime () {
      const token = cookies.get('Authorization')
      const CBLTime = await axios.post('/api/cems/winBid15Dmd',
        {
        },
        {
          headers: { Authorization: `bearer ${token}` }
        })
      if (CBLTime.data.success) {
        this.CBLTime = CBLTime.data
      }
    }
  },
  async mounted () {
    importJQ()
    this.getCBLTime()
    this.reserverateProgress()
    this.getSolarKwToday()
    await this.getContractRate()
    this.light('士林區行政中心')
  },
  computed: {
    ...mapGetters([
      'getTimenow'
    ]),
    ...mapState([
      'login',
      'navbar',
      'weather',
      'pop',
      'reserverate',
      'currentWeather',
      'solarKwh',
      'contractRate'
    ])
  }
}
</script>
